import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import DataGrid from "../../app/grid/DataGrid";
import { IReport7ApplicantPresentationModel } from "../../../../presenter/report/model/Report7ApplicantPresentationModel";
import NumberFormatter from "../../../../model/common/NumberFormatter";

const Report7PReviewNumericValuesGrid = ({
  translate,
  applicant
}: {
  translate: TTranslate;
  applicant: IReport7ApplicantPresentationModel;
}) => {
  const columns = [
    {
      key: "formStructureSectionName",
      dataIndex: "formStructureSectionName",
      title: translate("report7_preview.form_structure_element")
    },
    {
      key: "amount",
      title: translate("report7_preview.amount"),
      align: "right",
      render: (record) => (
        <div>{NumberFormatter().formatReadOnlyValue(record.amount)}</div>
      )
    },
    {
      key: "numberOfNumericValues",
      dataIndex: "numberOfNumericValues",
      title: translate("report7_preview.number_of_numeric_values"),
      align: "right"
    }
  ];

  return (
    <DataGrid
      key={`numeric-values-${applicant.id}`}
      translate={translate}
      columns={columns}
      dataSource={applicant.numericValues}
    />
  );
};

export default Report7PReviewNumericValuesGrid;
